import { printCommands } from './printCommands';
import { printPanels } from './printPanels';

export const printPlugin = (editor) => {
	printCommands(editor);
	printPanels(editor);
};
